const PREFIX = 'dashboard/';

// LocalStorage variables
export const LS_SIDEBAR_COLLAPSED = 'sidebarCollapsed';
export const LS_SIDEBAR_SHOW_USAGE = 'sidebarShowUsage';

// Redux constants
export const TOGGLE_SIDEBAR = `${PREFIX}TOGGLE_SIDEBAR`;
export const TOGGLE_MOBILE_MENU = `${PREFIX}TOGGLE_MOBILE_MENU`;
export const CLOSE_MOBILE_MENU = `${PREFIX}CLOSE_MOBILE_MENU`;
export const TOGGLE_SHOW_USAGE = `${PREFIX}TOGGLE_SHOW_USAGE`;
export const SET_SHOW_USAGE = `${PREFIX}SET_SHOW_USAGE`;
